// Function loadSiteFooterWoolLab loads the SiteFooterWoolLab class by dynamically importing the js on demand if needed

export function loadSiteFooterWoolLab($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-site-footer-chunk" */ '../widgets/siteFooterWoolLab').then(wg => {

		const { SiteFooterWoolLab } = wg;

		let $wg = $parentEl.querySelector('[data-wg="SiteFooterWoolLab"]');

		if(!$wg) {
			// console.info('SiteFooterWoolLab: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SiteFooterWoolLab"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new SiteFooterWoolLab($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SiteFooterWoolLab($wg);
		}


	}).catch(error => error+'An error occurred while loading the SiteFooterWoolLab widget');

}
